import fetch from '@/plugins/axios'
import dayjs from 'dayjs';

export default {
    namespaced: true,
    state: {
        list: [],
        pager: {},
        tmentNum: 0,
        loading: false
    },
    mutations: {
        setState(state: any, {key, data}: any) {
            state[key] = data;
        },
        // 快递出库后改变本地数据
        changeList(state: any, index: number) {
            if (state['list'][index].status == '0') {
                state['list'][index].status = '1';
                state['list'][index].outtime = dayjs().format('MM-DD HH:mm');
            } else {
                state['list'][index].status = '0';
            }
        }
    },
    actions: {
        async treatment({}, params){
            return fetch({
                url: '/client/treatment',
                params
            })
        },
        async getTreaTmentNum({commit}){
            const res = await fetch({
                url: '/client/treatment/num',
            })
            commit('setState', {key: 'tmentNum', data: res});
        },
        // 获取派件列表
        async getPackagesList({commit}: any, params: any) {
            commit('setState', {key: 'loading', data: true})
            const res: any = await fetch({
                url: '/client/packages',
                params
            })
            res.docs.forEach((item: any) => {
                item.intime = item.intime.split('-')[1] + '-' + item.intime.split('-')[2].split(':')[0] + ':' + item.intime.split('-')[2].split(':')[1]
                item.outtime = item.outtime ? item.outtime.split('-')[1] + '-' + item.outtime.split('-')[2].split(':')[0] + ':' + item.outtime.split('-')[2].split(':')[1] : ''
            })
            commit('setState', {key: 'list', data: res.docs})
            commit('setState', {key: 'pager', data: {limit: res.limit, total: res.total}})
            commit('setState', {key: 'loading', data: false})
        },
        // 通过快递单号查询
        async getCodeInfo({commit}: any, id: string) {
            return await fetch({
                url: `/client/packages/${id}`
            })
        },
        // 快递出库
        async outbound({commit}: any, {data, id}: any) {
            commit('setState', {key: 'loading', data: true})
            const res = await fetch({
                url: `/client/packages/outbound/${id}`,
                method: 'put',
                data,
            })
            commit('setState', {key: 'loading', data: false})
            return res
        },
        // async outboundChangeData({ commit,state }: any, index: number) {
        // 	commit('setState',{key:'pager',data: {limit: state.state}})
        // },
        // 已派件登记
        async register({commit}: any, params: any) {
            return await fetch({
                url: `/client/packages/register`,
                method: 'post',
                data: params
            })
        },
        // 修改快递员
        async modifyPartner({commit}: any, params: any) {
            return await fetch({
                url: `/client/packages/changePartner/${params.id}`,
                method: 'put',
                data: params.data
            })
        },
        // 修改货架
        async modifyShelf({}, params: any) {
            return await fetch({
                url: `/client/packages/changeShelf/${params.id}`,
                method: 'put',
                data: params.data
            })
        },
        // 修改电话号码
        async modifyPhone({commit}: any, params: any) {
            return await fetch({
                url: `/client/packages/changePhone/${params.id}`,
                method: 'put',
                data: params.data
            })
        },
        // 修改备注
        async modifyDesc({commit}: any, params: any) {
            return await fetch({
                url: `/client/packages/changeDesc/${params.id}`,
                method: 'put',
                data: params.data
            })
        },
        // 重新入库
        async againInbond({commit}: any, id: string) {
            return await fetch({
                url: `/client/packages/inbondAgain/${id}`,
                method: 'put'
            })
        },
        // 修改快递单号
        async modifyCode({commit}: any, params: any) {
            return await fetch({
                url: `/client/packages/changeCode/${params.id}`,
                method: 'put',
                data: params.data
            })
        },
        // 重新发送短信
        async againSendSms({commit}: any, id: string) {
            return await fetch({
                url: `/client/packages/resSendSms/${id}`,
                method: 'put'
            })
        },
        // 发送催收短信
        async sendRushSms({commit}: any, id: string) {
            return await fetch({
                url: `/client/packages/sendReSms/${id}`,
                method: 'put'
            })
        },
        async getStockAnalysisData() {
            return await fetch({
                url: `/client/stockAnalysis`,
            })
        },
        async getlegacyAnalysis() {
            return await fetch({
                url: `/client/legacyAnalysis`,
            })
        },
        async outboundSign({}, id) {
            return await fetch({
                method: 'put',
                url: `/client/outboundSign/${id}`,
            })
        },
        async outboundDeparture({}, id) {
            return await fetch({
                method: 'put',
                url: `/client/outboundDeparture/${id}`,
            })
        },
        // 导出派件数据
        async exportPackagesData({commit}: any, params: any) {
            commit('setState', {key: 'loading', data: true})
            const res = await fetch({
                url: `/client/packages/export/excel`,
                method: 'get',
                params
            })
            commit('setState', {key: 'loading', data: false})
            return res
        },
        // 入站
        async inboundPachages({commit}: any, params: any) {
            commit('setState', {key: 'loading', data: true})
            const res = await fetch({
                url: `/common/uploadLogicInfoAgain/${params.id}/${params.type}`,
                method: 'put'
            })
            commit('setState', {key: 'loading', data: false})
            return res
        }
    }
}